// MathLive (Cortex) — loader idempotente via CDN. MathLive é o "Word Equation"
// visual: o usuário compõe a fórmula clicando em sobrescrito/fração/raiz/etc.
// e o componente emite LaTeX. Usamos pra dar ao admin uma forma amigável de
// inserir matemática/química dentro do editor visual de bancos sem digitar
// LaTeX cru.
//
// Carregado sob demanda — só quando o admin abre o modal de equação. O CSS
// embutido do próprio MathLive já cobre o math-field; não precisa de extra.

const MATHLIVE_VERSION = "0.105.0";
let mathlivePromise: Promise<void> | null = null;

declare global {
  interface HTMLElementTagNameMap {
    "math-field": HTMLElement & {
      value: string;
      readonly: boolean;
      setValue: (latex: string) => void;
    };
  }
}

export function ensureMathLive(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve();
  if (customElements.get("math-field")) return Promise.resolve();
  if (mathlivePromise) return mathlivePromise;
  mathlivePromise = new Promise<void>((resolve, reject) => {
    const s = document.createElement("script");
    s.type = "module";
    s.src = `https://cdn.jsdelivr.net/npm/mathlive@${MATHLIVE_VERSION}/dist/mathlive.min.mjs`;
    s.onload = () => {
      // Espera o custom element registrar (load do módulo é assíncrono).
      const tick = () => {
        if (customElements.get("math-field")) resolve();
        else setTimeout(tick, 30);
      };
      tick();
    };
    s.onerror = () => reject(new Error("MathLive falhou ao carregar."));
    document.head.appendChild(s);
  });
  return mathlivePromise;
}
